module.exports = __webpack_public_path__ + "img/bigtitle.cdee8c62.png";